import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';
import {
  InspectorControlsAppearance,
  InspectorControlsGeneral,
  InspectorTabs,
} from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import ClassDropdown from '@components/class-dropdown';
import Label from '@components/block-label';
import { DEFAULT_CSS_CLASS } from '@constants';

import './editor.scss';

const InspectorGeneral = (props) => {
  const {
    attributes: { blockVisibility, label },
    setAttributes,
  } = props;
  return (
    <>
      <InspectorControlsGeneral>
        <Label {...{ label, setAttributes }} />
        <Visibility {...{ blockVisibility, setAttributes }} />
      </InspectorControlsGeneral>
    </>
  );
};

const InspectorAppearance = (props) => {
  const {
    attributes: { blockClassNames },
    setAttributes,
  } = props;

  return (
    <>
      <InspectorControlsAppearance>
        <ClassDropdown
          {...{
            blockClassNames,
            setAttributes,
            blockClassPrefix: DEFAULT_CSS_CLASS.SPAN,
            initialOpen: true,
          }}
        />
      </InspectorControlsAppearance>
    </>
  );
};

const Edit = (props) => {
  const {
    attributes: { blockVisibility, blockClassNames },
    clientId,
    context: { allowedBlocksInsideSpan },
  } = props;

  const GetAllowedBlocks = (allowedBlocksList) => {
    if (Object.keys(allowedBlocksList ? allowedBlocksList : {}).length > 0) {
      return allowedBlocksList;
    }
    return null;
  };

  const getDropDownClasses = blockClassNames
    ?.map((classes) => classes.value)
    .join(' ');

  const blockProps = useBlockProps(
    {
      className: `${DEFAULT_CSS_CLASS.SPAN} ${getDropDownClasses} ${
        blockVisibility !== true ? 'disable' : null
      }`,
    },
    {
      allowedBlocks: GetAllowedBlocks(allowedBlocksInsideSpan),
    },
  );

  const innerBlockCount = useSelect(
    (select) => select('core/block-editor').getBlock(clientId).innerBlocks,
  );

  const appenderToUse = () => {
    if (innerBlockCount.length < 1) {
      return <InnerBlocks.ButtonBlockAppender />;
    }
    return <></>;
  };

  return (
    <>
      <InspectorTabs>
        <InspectorGeneral {...props} />
        <InspectorAppearance {...props} />
      </InspectorTabs>
      <span {...blockProps}>
        <InnerBlocks
          allowedBlocks={allowedBlocksInsideSpan}
          renderAppender={() => appenderToUse()}
        />
      </span>
    </>
  );
};

export default Edit;
